import React from 'react'
import { Box, Menu, MenuItem, Typography, useTheme } from '@mui/material';

const CommonMenuItems = ({ anchorEl, open, onClose, mnenuItems, active }) => {
    const theme = useTheme();
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 0.2px 1px rgba(0,0,0,0.01))',
                    border: `1px solid ${theme.palette.background.default}`,
                    borderRadius: "10px",
                    bgcolor: '#FFFFFF',
                    mt: 1.5,
                    '& .MuiButtonBase-root' : {
                        padding : '0px'
                    },
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 15,
                        width: 15,
                        height: 18,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {mnenuItems?.map((ele, index) => {
                return (
                    <MenuItem key={index} onClick={ele?.onClick}>
                        <Box bgcolor={index === active ? "#0000000a" : theme.palette.bgWhite.main} width={'100%'} py={1} px={2}>
                            <Typography fontWeight={400} color={theme.palette.bgBlack.main} fontSize={'12px'} >{ele?.name}</Typography>
                        </Box>
                    </MenuItem>
                )
            })}
        </Menu>
    )
}

export default CommonMenuItems